import { render, staticRenderFns } from "./FinancesIncomeCategoriesForm.vue?vue&type=template&id=018c19c4&scoped=true"
import script from "./FinancesIncomeCategoriesForm.vue?vue&type=script&lang=js"
export * from "./FinancesIncomeCategoriesForm.vue?vue&type=script&lang=js"
import style0 from "./FinancesIncomeCategoriesForm.vue?vue&type=style&index=0&id=018c19c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018c19c4",
  null
  
)

export default component.exports